import { ISettings, LocationMarker } from '@/interfaces/settings.interfaces';

export type LocationTypes = 'dealer' | 'dealership' | 'country' | 'city';

export const locationMarkerKeysMap: Record<LocationMarker, LocationTypes> = {
  dealer: 'dealer',
  dealership: 'dealership',
  country: 'country',
  city: 'city',
};

/**
 * Возвращает массив типов данных для маркера местоположения.
 */
const getLocationMarkerKey = (settings: ISettings) => {
  const locationMarkerType = Array.isArray(settings.locationMarker)
    ? settings.locationMarker.map(locationMarker => locationMarkerKeysMap[locationMarker])
    : locationMarkerKeysMap[settings.locationMarker];

  return locationMarkerType;
};

export default getLocationMarkerKey;
